import Vue from 'vue';

const errorHub = new Vue();

export default errorHub;
